import React from 'react';
import { ContainerExample } from '../../components/UISystem/Layout';
import IconBack from '../../components/UISystem/Icons/IconBack';
import { UI_SCREEN_STYLES } from '../../styles/UISystem';

/**
 * LayoutScreen
 * 
 * Showcase for layout components including Container
 */
const LayoutScreen = ({ onBack }) => {
  return (
    <div style={UI_SCREEN_STYLES.container}>
      {/* Header */}
      <div style={UI_SCREEN_STYLES.header}>
        <div 
          onClick={onBack} 
          style={UI_SCREEN_STYLES.backButton}
        >
          <IconBack />
        </div>
        <h1 style={UI_SCREEN_STYLES.title}>Layout</h1>
      </div>
      
      {/* Divider */}
      <div style={UI_SCREEN_STYLES.divider}></div>
      
      {/* Content */}
      <div style={UI_SCREEN_STYLES.content}>
        <ContainerExample />
      </div>
    </div>
  );
};

export default LayoutScreen;
